import { Injectable } from '@angular/core';
import { createAction, props, Store } from '@ngrx/store';
import { AppState } from '../../app.state';

export const updateExpiringCredentialsCount = createAction(
  '[ExpiringCredentials] Update ExpiringCredentials',
  props<{ userCount: number; totalCount: number }>()
);

@Injectable({ providedIn: 'root' })
export class ExpiringCredentialCountActionsService {
  constructor(private store: Store<AppState>) {}

  updateExpiringCredentialsCount = (userCount: number, totalCount: number): void =>
    this.store.dispatch(updateExpiringCredentialsCount({ userCount, totalCount }));
}
